import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";

const LatestNews = ({ data }) => {
  return (
    <div className="news-section">
      <Container>
        <Row>
          <Col sm={12}>
            <div className="text-size-44">Latest Millennium News</div>
          </Col>
        </Row>
        <Row>
          {data?.nodes?.map((post, index) => (
            <Col md={6} key={index}>
              <div className="news-box mt-4">
                <div className="news-thumb">
                  {post.featuredImage?.node?.localFile && (
                    <GatsbyImage
                      image={getImage(post?.featuredImage?.node?.localFile)}
                      alt={
                        post.featuredImage?.node?.altText ||
                        post.title ||
                        "Post image"
                      }
                    />
                  )}

                    <span className="news-category-title">
                      {post?.categories?.nodes?.map((category, idx) => (
                        <Link
                          to={category.uri}
                          key={category.slug}
                          className="text-decoration-none"
                        >
                          {category.name}
                          {idx < post.categories.nodes.length - 1 && ", "}
                        </Link>
                      ))}
                    </span>
                </div>
                <div className="">

                  <div className="news-link  my-2">
                    <p className="mb-0">
                      <Link className="text-decoration-none" to={post.uri}>{post.title}</Link>
                    </p>
                  </div>
                  <div className="news-date-sec">
                      <span className="month-name">By</span>{" "}
                      <span className="news-author">
                        {post.author?.node?.name || "Unknown"}
                      </span>{" "}
                      <span className="month-name">{post.date}</span>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default LatestNews;
